import { Component, OnInit, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from 'src/app/services/common.service';
import { APIService } from 'src/app/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rpt-prd-prodn-output',
  templateUrl: './rpt-prd-prodn-output.component.html',
  styleUrls: ['./rpt-prd-prodn-output.component.scss']
})
export class RptPrdProdnOutputComponent implements OnInit {

//Table sort and column
displayedColumns: string[] = ['PrdName', 'LaunchQty', 'ComplnQty', 'Unit', 'RejPer'];
dataSource = new MatTableDataSource();

@ViewChild('mtlAviaTable', { static: false }) mtlAviaTable!: ElementRef;

@ViewChild(MatPaginator)
set paginator(value: MatPaginator) {
  this.dataSource.paginator = value;
}

@ViewChild(MatSort) set matSort(sort: MatSort) {
  this.dataSource.sort = sort;
}

ngAfterViewInit() {
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.matSort;
}

//Variable Declaration
agencyData: any = [];
jarvisData: any = [];
productionOutPutList:any = [];
exportToExcel:any = [];
curDate: any = new Date();
months: any = [];
monthDisplay: any = [];
month = this.curDate.getMonth();
year = this.curDate.getFullYear();

  constructor(private router: Router, private apiService: APIService, public CmnService: CommonService, private SpinnerService: NgxSpinnerService) { 
   
  }

  ngOnInit(): void {
    this.months = this.CmnService.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date().customFormat("#DD#-#MMM#-#YY#"));
    this.months = this.months.reverse();
    this.monthDisplay = this.months[0].display;
    // this.monthDisplay = this.months[this.months.length - 1].display;

    this.getData();
  }

  trasYearChange() {
    debugger
    let selecetdYear = this.months.filter((a: any) => a.display == this.monthDisplay);
    this.year = selecetdYear[0].year;
    this.month = selecetdYear[0].number;
    this.getData();
  }

   //Get Data - Call API
   getData() {

    let agencyData = this.apiService.getCookie('M');
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    var jarvis = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    let data = [
      {
        Month: this.month,
        Year: this.year,
      }
    ]
    
    let myParams = [
      {
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'getProductionOutput',
        moduleID: 8,
        data: JSON.stringify(data),
      },
    ];
    this.SpinnerService.show();
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this)
    );
  }

  //Success Response - Success handler
  successResp(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1000) {
          alert(reponseData.Table[0].ErrMsg);
          window.location.href = "main.html#/home";
        } else {
          if (reponseData.Table[0].ErrCode == -1) {
            this.productionOutPutList = reponseData.Table1;
            this.productionOutPutList.forEach((p: any) => {
              p.LaunchQty = Number(p.LaunchQty).toFixed(p.Prcsn);
              p.ComplnQty = Number(p.ComplnQty).toFixed(p.Prcsn);

              if(p.LaunchQty == 0)
              {
                p.RejPer = 0;
              }
              else{
                p.RejPer = Math.round((p.RejQty / p.LaunchQty) * 100) ;

              }

              });
            console.log(this.productionOutPutList)
            this.dataSource.data = this.productionOutPutList;
            this.dataSource.data = this.dataSource.data.sort((a: any, b: any) => a.PrdName.localeCompare(b.PrdName))

            this.exportToExcel = this.productionOutPutList;
            this.dataSource.paginator = this.paginator; 
            this.dataSource.sort = this.matSort;

            
          }
        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    } else {
      alert(res.message);
    }
  }

  //search
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.exportToExcel = this.dataSource.filteredData;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  backBtn() {
    this.router.navigate(['/ProductionList']);
  }


//export to excel
exportToExcelActivities() {
  debugger
      var html = "";
      html += "<table><tr>";
      html += "<th style='text-align: left;'>Production Output</th>"
      html += "</table></tr>";
      html += "<table><tr></table></tr>";
      html += "</table></tr>";
      html += "</table></tr>";
      
      html += "<p><b>  Month : </b>"+ this.monthDisplay +  "</p>"
      // Blank Column
      html += "<table><tr></table></tr>";
      html += "<table><tr>";

  var strHeader = ""
  strHeader += "<th style='text-align: left;'>Product</th>";
  strHeader += "<th style='text-align: right;'>Launched</th>";
  strHeader += "<th style='text-align: right;'>Output</th>";
  strHeader += "<th style='text-align: left;'>Unit</th>";
  strHeader += "<th style='text-align: right;'>Rejection</th>";
  strHeader += "</tr>"
  html += strHeader;

  var body = "";
  this.exportToExcel.forEach((productionOutPutList:any, key:any) => {
    body += "<tr>";
    body += "<td style='text-align: left;'>" + productionOutPutList.PrdName +  "</td>";
    body += "<td style='text-align: right;'>" + (productionOutPutList.LaunchQty) + "</td>";
    body += "<td style='text-align: right;'>" + (productionOutPutList.ComplnQty) + "</td>";
    body += "<td style='text-align: left;'>" + productionOutPutList.Unit  + "</td>";
    body += "<td style='text-align: right;'>" + productionOutPutList.RejPer +'%'  + "</td>"
   
  body += "</tr>";
  })

 
  html += body;
  html += "</table>";
  this.tableToExcel(html, 'Sheet1', 'Consumption Analysis');  
}

  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
      , base64 = function (s: any) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s: any, c: any) { return s.replace(/{(\w+)}/g, function (m: any, p: any) { return c[p]; }) }

    return function (table: any, name: string, fileName: any) {
      if (!table.nodeType) table = table
      var ctx = { worksheet: name || 'Worksheet', table: table }
      //window.location.href = uri + base64(format(template, ctx))
      var link = document.createElement("a");
      link.download = fileName || 'download.xls';
      link.href = uri + base64(format(template, ctx));
      link.click();
    }
  })()
}
